import { RoleDto } from "@cs/RoleDto";
import { ContainerDto } from "@cs/ContainerDto";
import { UserDto } from "@cs/UserDto";

export type RoleDtoExtension = { Container: string; RoleName: string; Cause: RoleDtoExtended };
export type RoleDtoDisabledExtension = { IsDisabled: boolean };
export type RoleDtoExtended = RoleDto & RoleDtoExtension & RoleDtoDisabledExtension;
export type GroupedRole = { Container: string; ContainerLabel?: string; RoleName: string; DirectAssignable?: boolean; RoleDisplayLabel?: string };
export type GroupedPermission = { Container: string; ContainerLabel: string; Permission: string };

export const userModalProps = ["containerData", "savingCallback"];
export const userModalPropsObject = { containerData: Object, savingCallback: Function };
export type UserModalProps = {
    containerData: ContainerDto;
    userInput: UserDto;
    savingCallback: (value: any) => Promise<void>; // eslint-disable-line @typescript-eslint/no-explicit-any
};
export function userModalSetup(props: UserModalProps) {
    const possibleRoles = (code: string) => {
        const container = getContainer(code, props.containerData);
        const containerRoles = (container?.Roles as unknown as RoleDtoExtended[]);
        containerRoles.forEach(x => x.IsDisabled = false);
        if (props.userInput != null && props?.userInput?.UserType == "System" && props?.userInput?.UserName?.startsWith("EVERYONE@")) {
            containerRoles.forEach(x => x.IsDisabled = !(["Submitter", "VisitorTester"].includes(x.Name)));
        }
        return containerRoles.filter(userDirectlyAssignableRoles) ?? [];
    };
    const subroles = (roles: RoleDtoExtended[]) => {
        const result = {} as Record<string, RoleDtoExtended[]>;
        const f = (role: RoleDtoExtension, cause: RoleDtoExtended) => {
            const roleData = getContainer(role.Container!, props.containerData)?.Roles.find(i => i.Name == role.RoleName);
            if (roleData == null) {
                return;
            }
            const subroles = {
                [role.Container!]: roleData.Subroles.map(i => ({
                    Container: role.Container,
                    RoleName: i,
                    Cause: cause,
                })),
            };
            for (const subRoleContainer of Object.keys(roleData.SubrolesFromOtherContainers)) {
                subroles[subRoleContainer] = roleData.SubrolesFromOtherContainers[subRoleContainer].map(i => ({ Container: subRoleContainer, RoleName: i, Cause: cause }));
            }
            for (const container of Object.keys(subroles)) {
                for (const subrole of subroles[container]) {
                    f(subrole, cause);
                }
                result[container] = (result[container] || []).concat(subroles[container] as unknown as RoleDtoExtended);
            }
        };
        for (const role of roles) {
            f(role, role);
        }
        return result;
    };
    const userDirectlyAssignableRoles = (containerRole: RoleDtoExtended) => {
        return containerRole.Subtype == "System-controlled";
    };
    const getContainerName = (code: string) => {
        return (getContainer(code, props.containerData) || {})?.ContainerName;
    };
    const getRoleDisplayLabel = (container: string, roleName: string) => {
        const role = (getContainer(container, props.containerData) || {})?.Roles?.find(i => i.Name == roleName);
        return role == null ? null : role.DisplayLabel || role.Name;
    };
    const getContainer = (code: string, containerData: ContainerDto): ContainerDto | null => {
        if (containerData.ContainerCode == code) {
            return containerData;
        } else {
            let result = null;
            containerData.SubContainers.some(i => {
                result = getContainer(code, i);
                return result;
            });
            return result;
        }
    };

    return {
        possibleRoles,
        subroles,
        userDirectlyAssignableRoles,
        getContainerName,
        getRoleDisplayLabel,
        getContainer,
    };
}
